"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SearchComponent_1 = __importDefault(require("../../components/header/SearchComponent"));
const notInitialized_1 = require("../../utils/notInitialized");
class SearchPresenter {
    constructor(parentElement, tracks, className, inputClass, placeholder, inputId) {
        this.parentElement = parentElement;
        this.tracks = tracks;
        this.className = className;
        this.inputClass = inputClass;
        this.placeholder = placeholder;
        this.inputId = inputId;
        this.searchChangeCallback = notInitialized_1.notInitialized;
        this.searchComponent = this.render();
    }
    render() {
        if (this.searchComponent) {
            this.searchComponent.removeElement();
        }
        this.searchComponent = new SearchComponent_1.default(this.className, this.inputClass, this.placeholder, this.inputId);
        this.parentElement.append(this.searchComponent.getElement());
        this.searchComponent.addOnChange((event) => {
            const input = event.currentTarget;
            if (!(input instanceof HTMLInputElement)) {
                throw new Error('Event target is not HTMLInputElement');
            }
            this.tracks.filterString = input.value;
            this.searchChangeCallback();
        });
        return this.searchComponent;
    }
}
exports.default = SearchPresenter;
